import React, { Component } from "react";
import classnames from "classnames";

import { Button } from "@formant/ui-kit";
import { HStack } from "@formant/ui/component/common/HStack";
import { VStack } from "@formant/ui/component/common/VStack";

import { Escape } from "../common/Escape";
import { Heading2 } from "../common/Heading2";
import { IconButton } from "../common/IconButton";
import { Popup } from "../common/Popup";
import * as styles from "./EditTeleopStreamPopup.scss";

export interface IEditTeleopStreamPopupProps {
    visible: boolean;
    onClose: () => void;
    className?: string;
    title?: string;
    children?: React.ReactNode;
}

export class EditTeleopStreamPopup extends Component<IEditTeleopStreamPopupProps> {
    public render() {
        const { visible, onClose, className, title, children } = this.props;
        return (
            <Popup
                visible={visible}
                variant="light"
                windowClassName={classnames(
                    styles["edit-teleop-stream-popup"],
                    className,
                )}
            >
                <Escape onEsc={onClose} />
                <VStack innerSpacing="md">
                    <div className={styles.header}>
                        {title && (
                            <Heading2 className={styles.heading}>
                                {title}
                            </Heading2>
                        )}
                        <IconButton
                            icon="close"
                            className={styles.close}
                            onClicked={onClose}
                        />
                    </div>
                    {children}
                    <HStack vAlign="center" hAlign="end">
                        <Button onClick={onClose} data-testid="done-button">
                            Done
                        </Button>
                    </HStack>
                </VStack>
            </Popup>
        );
    }
}
